import { Resource } from "react-admin";
import ProjectsList from "./project/ProjectList";
import CreateProject from "./project/ProjectCreate";
import EditProjects from "./project/ProjectEdit";
import ShowProjects from "./project/ProjectShow";

const projectsResource = () => (
  <Resource
    name="projects"
    options={{ label: "Projects", menuGroup: "Projects" }}
    list={ProjectsList}
    create={CreateProject}
    edit={EditProjects}
    show={ShowProjects}
  />
);

export default projectsResource;
